import React, { useEffect } from "react";
import "./EducationPage.css";

const HospitalityPage = () => {

  useEffect(() => {
    const cards = document.querySelectorAll(".card-wrapper");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            requestAnimationFrame(() => {
              entry.target.classList.add("show");
            });
          } else {
            entry.target.classList.remove("show");
          }
        });
      },
      {
        threshold: 0.45,
        rootMargin: "0px 0px -150px 0px",
      }
    );

    cards.forEach((card) => observer.observe(card));

    return () => {
      cards.forEach((card) => observer.unobserve(card));
    };
  }, []);

  const hospitalityData = [
    {
      title: "The Retreat Darjeeling",
      desc: (
        <p>
          "With the sublime view of Kanchenjunga from the window, this boutique hotel offers an
          exquisite experience – quiet luxury alongside the majesty of nature in its purest form.
          Discover Darjeeling like never before, while enjoying authentic food at the in-house cafe,
          as well as, from the elegant, multi-cuisine restaurant. ​"
        </p>
      ),
      img: "/images/ecosystem/Retreat.jpg",
      link: "https://theretreatdarjeeling.com/"
    },
    {
      title: "Cafe House",
      desc: (
        <p>
          "How about having absolutely gourmet food from a well-curated menu? And that too,
          while cherishing the raw beauty of Kanchenjunga in solitude? That’s what sums up the
          enviable experience one can have at The Retreat Darjeeling’s in-house cafe, which goes
          by the name, Cafe House. Come, enjoy Darjeeling while munching on some exotic dishes
          in a serene setting.​"
        </p>
      ),
      img: "/images/ecosystem/Cafe-house.jpg",
      link: "https://theretreatdarjeeling.com/cafe-house"
    },
    {
      title: "Aroma",
      desc: (
        <p>
          "Premium dining experience, dipped in elegance and authenticity with Kanchenjunga at
          your side. From your comfort meals to continental, Chinese and even, absolutely genuine
          Nepali cuisine (which still remains a rarity in Darjeeling) alongside our chef’s specials –
          choose from an array of sumptuous dishes, curated with utmost care. At Aroma, unique
          taste meets quiet luxury and the experience becomes truly unforgettable.​"
        </p>
      ),
      img: "/images/ecosystem/Aroma.jpg",
      link: "https://theretreatdarjeeling.com/aroma"
    }
  ];

  return (
    <div>

      <div className="inner-banner-wrapper">
        <img
          src="/images/page-banner/about.png"
          alt="Banner"
          className="inner-banner-img"
        />
        <div className="inner-banner-overlay">
          <div className="inner-banner-text">Hospitality</div>
        </div>
      </div>

      <div className="overview-container">
        <div className="contain-body">

          {hospitalityData.map((item, index) => (
            <div
              className={`card-wrapper ${index % 2 === 1 ? "reverse" : ""}`}
              key={index}
            >

              <div className="card-text">
                <h2>{item.title}</h2>
                {item.desc}

                <a
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="learn-more-link"
                >
                  <span className="learn-more-icon">➜</span>
                  <span>Learn more</span>
                </a>
              </div>

              <div className="card-image">
                <img src={item.img} alt={item.title} />
              </div>

            </div>
          ))}

        </div>
      </div>

    </div>
  );
};

export default HospitalityPage;